function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 11,
  x: 0.5,
  y: 0.5,
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#D3D4DD",
  rx: 2.12
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8C54",
  d: "M7.991 5.99a2 2 0 0 1 2 2v2h-7.98v-2a2 2 0 0 1 2-2zM6.001 2a1.663 1.663 0 1 1 0 3.325 1.663 1.663 0 0 1 0-3.325z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#873D00",
  d: "M6 8c1.334 0 2-.662 2-1.987L4 6c.001 1.333.668 2 2 2z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 2,
  x: 12,
  y: 5,
  fill: "#7A7B8E",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  fillRule: "nonzero",
  stroke: "#D3D4DD",
  d: "M18.023 14.499L2.12 14.5A1.62 1.62 0 0 0 .5 16.12v7.76c0 .895.725 1.62 1.62 1.62l15.495.001A7.68 7.68 0 0 1 15.5 20.2c0-2.215.943-4.267 2.523-5.701z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003A79",
  d: "M23.2 14.6a5.6 5.6 0 0 1 4.478 8.964l3.496 3.495a.8.8 0 0 1-1.132 1.13l-3.497-3.498A5.6 5.6 0 1 1 23.2 14.6zm0 1.6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7B8E",
  d: "M19.581 18.5H22.7a1.5 1.5 0 1 1 0 3h-3.294c-.164-.433-.233-.933-.206-1.5.027-.567.154-1.067.381-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8C54",
  d: "M7.991 19.99a2 2 0 0 1 2 2v2h-7.98v-2a2 2 0 0 1 2-2zM6.001 16a1.663 1.663 0 1 1 0 3.325 1.663 1.663 0 0 1 0-3.325z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#873D00",
  d: "M6 22c1.334 0 2-.662 2-1.987L4 20c.001 1.333.668 2 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7B8E",
  d: "M13 19h2.093c-.097.585-.116 1.252-.056 2H13a1 1 0 0 1 0-2z"
}));

var SvgAcompanhamentoCondicoesSaude = function SvgAcompanhamentoCondicoesSaude(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAcompanhamentoCondicoesSaude, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/acompanhamento-condicoes-saude.897e4957.svg";
export { ForwardRef as ReactComponent };